import { createApp } from 'vue';
import Rw2ToJpgConverter from '../Components/Rw2ToJpgConverter.vue';

const root = document.getElementById('rw2-to-jpg-converter');
if (root) {
  createApp(Rw2ToJpgConverter).mount('#rw2-to-jpg-converter');
}
